// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2Ej4m","content":"ManualTimeModal_content__16oAb"};